// extracted by mini-css-extract-plugin
export default {"text-block":"clipboardTextField-module__text-block___G3T4j","text-block_one-line":"clipboardTextField-module__text-block_one-line___ilRBX"};